import axios from 'axios';

export const getEmbeddableToken = async (embeddableId: string, environment?: string, securityContext?: any) => {
    const payload: any = { embeddableId, environment };

    if (securityContext) {
        payload.securityContext = securityContext;
    }

    return axios.post(
        `${process.env.REACT_APP_API_URL}dashboards/embeddable-token/`,
        payload
    );
}; 